import type { RosterEmployee } from '@/api/competency-services/profile-assignment/profileAssignmentService';

type DirectoryUserLike = {
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    emailAddress?: string | null;
    profilePictureUrl?: string | null;
    departmentId?: string | null;
    jobTitleId?: string | null;
    employeeLevelId?: string | null;
    companyAddressId?: string | null;
    isActive?: boolean;
};

/** Build a RosterEmployee when the employee is missing from the roster response. */
export const buildRosterEmployee = (
    user: DirectoryUserLike,
    overrides?: Partial<RosterEmployee>,
): RosterEmployee => ({
    id: user.id,
    firstName: user.firstName ?? '',
    lastName: user.lastName ?? '',
    emailAddress: user.emailAddress ?? '',
    profilePictureUrl: user.profilePictureUrl ?? null,
    departmentId: user.departmentId ?? null,
    jobTitleId: user.jobTitleId ?? null,
    employeeLevelId: user.employeeLevelId ?? null,
    companyAddressId: user.companyAddressId ?? null,
    isActive: user.isActive ?? true,
    assignedProfileId: null,
    assignedProfileName: null,
    addedCompetencyIds: [],
    removedCompetencyIds: [],
    ...overrides,
});
